import { FreeData } from "firebaseUtil/firebaseUtil";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: FreeData = { init: true };

const appTransPartsSlice = createSlice({
  initialState,
  name: "appTransParts",
  reducers: {
    setAppTransParts: (state: any, action: PayloadAction<FreeData>) => {
      return action.payload;
    },
  },
});

export const { setAppTransParts } = appTransPartsSlice.actions;

export default appTransPartsSlice.reducer;
